import type { ReactNode } from "react";

/**
 * Gemeinsames Layout für alle rechtlichen Seiten (Impressum, Datenschutz, AGB).
 * Sorgt für ein konsistentes typografisches Bild: gute Lesbarkeit auf
 * Mobile, klare Hierarchie, ausreichend Zeilenabstand.
 */
export default function LegalLayout({
  title,
  lastUpdated,
  children,
}: {
  title: string;
  /** ISO-Date, z.B. "2026-04-22". Dient Transparenz und DSGVO Art. 12. */
  lastUpdated: string;
  children: ReactNode;
}) {
  return (
    <article className="mx-auto max-w-3xl prose-slate">
      <header className="mb-8 border-b border-slate-800 pb-6">
        <h1 className="text-3xl font-bold text-white">{title}</h1>
        <p className="mt-2 text-sm text-slate-400">
          Stand: {new Date(lastUpdated).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })}
        </p>
      </header>
      <div className="space-y-6 text-slate-200 leading-relaxed [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-white [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-slate-100 [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:my-3 [&_a]:text-court-300 [&_a]:underline hover:[&_a]:text-court-200 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_li]:my-1 [&_strong]:text-white">
        {children}
      </div>
    </article>
  );
}
